'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'ranking-star';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e561';
var svgPathData = ['M32 368c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-96zM245 92.2l43.4-6.3 8.3-1.2 3.7-7.5L320 37.8l19.5 39.4 3.7 7.5 8.3 1.2 43.4 6.3-31.4 30.3-6.1 5.9 1.4 8.3 7.4 43.3-38.7-20.3-7.5-3.9-7.4 3.9-39 20.6 7.4-43.3 1.4-8.3-6-5.9L245 92.2zM256 304c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-160zM480 432c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-32z', 'M300.5 77.2l-3.7 7.5-8.3 1.2L245 92.2 276.6 123l6 5.9-1.4 8.3-7.4 43.3 39-20.6 7.4-3.9 7.5 3.9 38.7 20.3-7.4-43.3-1.4-8.3 6.1-5.9 31.4-30.3-43.4-6.3-8.3-1.2-3.7-7.5L320 37.8 300.5 77.2zm-5-62c10.3-20.6 39.4-19.9 49.1 .1l19.9 40.2 44 6.3 .2 0s0 0 0 0c22.1 3.4 31.5 30.6 15.3 46.9l-.2 .2s0 0 0 0l-31.9 30.8 7.5 43.7 0 .3s0 0 0 0c3.4 22-19.5 39.1-39.8 28.9l-.3-.1s0 0 0 0L320.2 192l-39.5 20.9-.3 .2s0 0 0 0c-20.3 10.2-43.2-6.9-39.8-28.9l0-.3s0 0 0 0l7.5-43.8-31.9-31.1-.2-.2s0 0 0 0c-16.2-16.2-6.7-43.5 15.3-46.9l.2 0s0 0 0 0l44-6.3 19.9-40.2c0 0 0 0 0 0zM192 368l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48zm224 64l0 32c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96 0-64c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 128zM256 304l0 160c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM32 368l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm448 64l0 32c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm16-48l96 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRankingStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;